// import {  } from '../utils/hooks/...';
// import {  } from 'components/...';

const HomePage = () => {

  // const {  }  = use___();
  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 40,
        color: '#010101'
      }}
    >
      Template online-store
    </div>
  );
}
export default HomePage;
